/*
  Mede o grupo de itens e ajusta a barra para o loop nunca deixar vão.

  O CSS sozinho já anima (2 cópias, deslocamento de 50%), mas isso só fecha se
  um grupo for mais largo que a viewport. Aqui a largura real é medida e:
    - --fb-shift vira a largura exata de um grupo em px;
    - cópias são clonadas até que, depois de um grupo sair pela esquerda, os
      restantes ainda cubram a tela inteira;
    - a duração vem da velocidade em px/s, então a barra anda no mesmo ritmo
      independente de quantos itens o lojista cadastrar.
*/
if (!customElements.get('scrolling-features-bar')) {
  customElements.define(
    'scrolling-features-bar',
    class ScrollingFeaturesBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-features-track]');
        this.template = this.track?.querySelector('[data-features-group]');
        if (!this.track || !this.template) return;

        this.layout = this.layout.bind(this);
        this.scheduleLayout = this.scheduleLayout.bind(this);

        this.layout();

        // A largura muda quando a fonte customizada termina de carregar.
        document.fonts?.ready.then(this.layout);

        this.resizeObserver = new ResizeObserver(this.scheduleLayout);
        this.resizeObserver.observe(this);

        // No editor, congela a barra enquanto um item está selecionado —
        // senão o bloco escolhido sai da tela antes do lojista ver a mudança.
        this.addEventListener('shopify:block:select', () => this.classList.add('features-bar--frozen'));
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('features-bar--frozen'));
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        clearTimeout(this.layoutTimer);
      }

      scheduleLayout() {
        clearTimeout(this.layoutTimer);
        this.layoutTimer = setTimeout(this.layout, 150);
      }

      layout() {
        const groupWidth = this.template.getBoundingClientRect().width;
        const viewportWidth = this.getBoundingClientRect().width;
        if (!groupWidth || !viewportWidth) return;

        // Depois que um grupo sai pela esquerda sobram (cópias - 1) grupos para
        // cobrir a tela. Daí o +1: é a folga que elimina o vão à direita.
        this.setGroupCount(Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1));

        const speed = Math.max(1, parseFloat(this.dataset.speed) || 60);
        this.style.setProperty('--fb-shift', `${groupWidth}px`);
        this.style.setProperty('--fb-duration', `${groupWidth / speed}s`);
      }

      setGroupCount(count) {
        const groups = this.track.querySelectorAll('[data-features-group]');
        if (groups.length === count) return;

        for (let i = groups.length; i > count; i--) {
          this.track.lastElementChild?.remove();
        }

        for (let i = groups.length; i < count; i++) {
          const clone = this.template.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          // Sem isso o editor enxergaria vários elementos como o mesmo bloco.
          clone
            .querySelectorAll('[data-shopify-editor-block]')
            .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(clone);
        }
      }
    }
  );
}
